export function messageOrderComparision(
  messageSentTime: string | undefined,
  entitySentTime: string | undefined,
): boolean {
  if (messageSentTime && entitySentTime) {
    const firstDate: number = new Date(messageSentTime).getTime();
    const secondDate: number = new Date(entitySentTime).getTime();
    return firstDate > secondDate;
  }

  return true;
}
